import React, { createContext, useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import { getWidgets, getRecentComments, getRecentPosts, getRecentContactMessages } from '../services/api';

export const DashboardContext = createContext();

export const DashboardProvider = ({ children }) => {
  const [widgets, setWidgets] = useState([]);
  const [recentComments, setRecentComments] = useState([]);
  const [recentPosts, setRecentPosts] = useState([]);
  const [recentContactMessages, setRecentContactMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDashboardData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [widgetsRes, commentsRes, postsRes, messagesRes] = await Promise.all([
        getWidgets(),
        getRecentComments(),
        getRecentPosts(),
        getRecentContactMessages()
      ]);
      setWidgets(widgetsRes.data);
      setRecentComments(commentsRes.data);
      setRecentPosts(postsRes.data);
      setRecentContactMessages(messagesRes.data);
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'خطا در دریافت داده‌های داشبورد';
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <DashboardContext.Provider
      value={{
        widgets,
        recentComments,
        recentPosts,
        recentContactMessages,
        loading,
        error,
        fetchDashboardData
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
};